import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAgencyType } from '../interfaces/agency-type';

@Injectable({
  providedIn: 'root'
})
export class AgencyTypeService {
  private rootUrl: string = "/api/agency-types";

  constructor(private httpClient: HttpClient) { }

  public getAgencyAdminAgencyTypes(username: string, appId: number): Observable<IAgencyType[]> {
    const url = this.rootUrl + "/agency-admin?username=" + username + "&appId=" + appId;
    return this.httpClient.get<IAgencyType[]>(url);
  }
}
